import React from 'react'

type LoaderProps = {
  className?: string,
}

function Loader(props: LoaderProps) {
  const { className= '' } = props

  return (
      <div className={`container ${className}`}>
        <div className="loader">
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--text"></div>
        </div>
      </div>
  )
}

export default Loader
